<template>
    <v-card>
        <v-toolbar flat color="primary" dark height="40" >
            <v-toolbar-title>Actions</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <div v-if="quoteData.statusId != 'Cancelled'">
                <v-layout row>
                    <v-flex xs12>
                        <div class="warning--text elevation-3">
                            <ul>
                                <li v-for="msg in warningMsgs" :key="msg">
                                    {{msg}}
                                </li>
                            </ul>
                            <!-- {{warningMsgs}} -->
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <v-text-field
                        name="txtNotes"
                        label="Notes"
                        v-model="notes"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <template v-for="action in quoteData.nextActions">
                        <v-btn :color="action.color" 
                            @click="onQuoteAction(action)"
                            :key="action.action">
                            {{action.action}}
                        </v-btn>

                    </template>
                </v-layout>
                <!-- <v-layout row wrap >
                    <v-alert
                    :value="true"
                    color="error"
                    outline
                    >
                    Validation Message:
                    <br>
                    {{quoteData.validateTerrMissedPdf}}.<br>
                    </v-alert>

                </v-layout> -->

            </div>
            <div v-else>No more Action for you.</div>

        </v-card-text>
        
    </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

// const Submit_To_Process = "Submit To Process";
// const Cancel = "Cancel";
// const Request_to_Approve_Discount = "Request to Approve Discount"
// const Approve_Discount = "Approve Discount"
// const Reject_Discount = "Reject Discount"
// const Sent_to_Customer = "Sent to Customer";
// const Submit_Revised_Quote_to_Customer = "Submit Revised Quote to Customer";
// const Need_More_Information = "Need More Information";
// const Quote_Won = "Quote_Won";
// const Quote_Lost = "Quote_Lost";
// const Need_Revise = "Need Revise";
// const Reopen = "Reopen";
// const AddNotes = "Add Notes";

export default {
    props: ['quoteData'],
    data () {
        return {
            notes: '',
            // warningMsgs: [],
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasPublicRole',
            'userHasInternalRole',
        ]),
        // business rule: if quote has discount > 5%, need approve
        ifQuoteNeedApproveDiscount () {
            return this.quoteData && this.quoteData.items.some(item => { return !!item.discountPct && item.discountPct >= 5})
        },
        warningMsgs() {
            var msgs = []
            if(this.quoteData.basicInfo.statusId=='Processing' && this.userHasInternalRole){
                // the docs[0] is the latest pdf record
                if (!this.quoteData.docs || this.quoteData.docs.length == 0){
                    msgs.push('Please generate pdf quote document! Salesforce needs it.')
                }
                if (!this.quoteData.basicInfo.facilityAcctNo){
                    msgs.push('Non GP customer, CS rep needs to enter this new customer into GP manually!')
                }
                if (!this.quoteData.basicInfo.contactId){
                    msgs.push('Non CRM contact, CS rep needs to enter this new contact into CRM manually!')
                }

            }
            return msgs
        }
 
    },
    methods: {
        ...mapActions('quoteWorkflow', [
            'performWorkflowAction'
        ]),
        async onQuoteAction (action) {
            if (action.requireNotes && !this.notes) {
                alert('Notes is required!')
                return
            }
            if (action.requireConfirm) {
                if(!confirm('Are you sure to perform this action?'))
                    return
            }
            // if (action.name == "Cancel") {
            //     if(!confirm('Are you sure to cancel this work? It is not reversible!'))
            //         return
            // }
            // if (action.name == "Submit Quote to Customer") {
            //     if(!confirm('Are you sure to submit pdf quote to customer?'))
            //         return
            // }
            // if (action.name == "Won" || action.name == 'Lost') {
            //     if(!confirm('Are you sure?'))
            //         return
            // }
            action.notes = this.notes
            let payload = action

            this.performWorkflowAction(payload)
                .then(() => {
                    // this.loadJobData()
                    // console.log("rpt gen ")
                    this.$emit('reloadQuoteData')
                    this.notes = ''
                })
                .catch(err => {
                    // console.log(JSON.stringify(err))
                    // this.$store.commit('setLoading', false, { root: true })

                    alert(err.response.data)
                })
        },
    },
    created () {
        // check if user could approve quote discount

    },
}
</script>
